/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxmAgentauthV1AgentKeyState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXM_AGENTAUTH_V1_AGENT_KEY_STATE_ENTITY_NAME = 'ixm.agentauth.v1.AgentKey';
export const ixmAgentauthV1AgentKeyStateEntity = new schema.Entity<IxmAgentauthV1AgentKeyState>(IXM_AGENTAUTH_V1_AGENT_KEY_STATE_ENTITY_NAME, {}, { idAttribute: 'agentId' });

